import { Button } from "@/components/ui/button"
import { useStepperContext } from "./stepper-provider"
import { cn } from "@/lib/utils";
import { MoveLeft, MoveRight, Loader2 } from "lucide-react"
export default function DistributionFooter({ requestItem, layout, hasUnsavedChanges, isLoading, noNext, onSubmit }: { requestItem: any, layout: boolean, hasUnsavedChanges: boolean, isLoading: boolean, noNext: boolean, onSubmit: () => void }) {
  const { currentStep, handleNext, handleBack } = useStepperContext();

  return (
    <div className={cn(
      "x-space gap-4 fixed w-full flex-center justify-end bottom-0 right-0 bg-white shadow-lg border-t border-grey/30 h-[80px]",
      layout && "fixed w-[calc(100%-170px)]"
    )}>
     {currentStep !== 'define' && <Button
        onClick={handleBack}
        className={cn(
          "w-[130px] rounded-lg hover:bg-[#EDF5FF]  bg-white border-2 border-blue text-blue semi-bold-16 text-md font-semibold"
        )}
      >
        <span><MoveLeft /></span> Back
      </Button>
}
      {hasUnsavedChanges && (
        <Button
          onClick={onSubmit}
          disabled={isLoading}
          className="w-[130px] flex items-center gap-1 hover:bg-[#EDF5FF]  bg-white rounded-lg border-2 border-blue text-blue font-semibold semi-bold-16 text-md"
        >
          {isLoading && <span><Loader2 size={20} className="animate-spin" /></span>}
          Save
        </Button>
      )}

      {!noNext && (
        <Button
          disabled={isLoading}
          className="w-[130px] button-style  bg-blue hover:bg-[#00336C]  rounded-lg flex items-center gap-2  semi-bold-16 text-md font-semibold"
          onClick={onSubmit}
        >
          {isLoading && <span><Loader2 size={20} className="animate-spin" /></span>}
          Next <span><MoveRight /></span>
        </Button>
      )}

      {/* {!pathname.includes('offline') && <DownloadButton projectId={projectId} />} */}
    </div>
  )
}
